export default function Footer() {
  const handleNavClick = (e: React.MouseEvent<HTMLAnchorElement>, href: string) => {
    e.preventDefault();
    const target = document.querySelector(href);
    if (target) {
      target.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <footer id="footer" className="bg-gray-900 text-gray-300">
      <div className="w-full px-4 md:px-6 py-16">
        <div className="max-w-7xl mx-auto">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10 mb-12">
            <div>
              <span className="text-2xl font-black text-white tracking-tight mb-4 block">90影视</span>
              <p className="text-sm text-gray-400 leading-relaxed mt-3">
                90影视提供电影、电视剧、综艺、动漫免费在线观看服务，高清画质无广告不缓冲，每日更新最新资源，是您省钱追剧的首选平台。
              </p>
            </div>

            <div>
              <h3 className="text-white font-semibold mb-4 text-sm">快速导航</h3>
              <ul className="space-y-2.5">
                {[
                  { label: '精彩推荐', href: '#media' },
                  { label: '热播榜单', href: '#ranking' },
                  { label: '精选专题', href: '#carousel' },
                  { label: '最新快讯', href: '#updates' },
                  { label: '常见问题', href: '#faq' },
                ].map((item) => (
                  <li key={item.href}>
                    <a
                      href={item.href}
                      onClick={(e) => handleNavClick(e, item.href)}
                      className="text-sm text-gray-400 hover:text-white transition-colors duration-200 no-underline cursor-pointer whitespace-nowrap"
                    >
                      {item.label}
                    </a>
                  </li>
                ))}
              </ul>
            </div>

            <div>
              <h3 className="text-white font-semibold mb-4 text-sm">内容分类</h3>
              <ul className="space-y-2.5">
                {['电影', '电视剧', '综艺', '动漫', '纪录片'].map((cat) => (
                  <li key={cat}>
                    <span className="text-sm text-gray-400 whitespace-nowrap">{cat}</span>
                  </li>
                ))}
              </ul>
            </div>

            <div>
              <h3 className="text-white font-semibold mb-4 text-sm">合作伙伴</h3>
              <p className="text-sm text-gray-500">暂无合作伙伴信息</p>
            </div>
          </div>

          <div className="border-t border-gray-800 pt-8 flex flex-col sm:flex-row items-center justify-between gap-4">
            <p className="text-xs text-gray-500">
              &copy; {new Date().getFullYear()} 90影视。本站内容仅供学习交流，请支持正版。
            </p>
            <div className="flex items-center gap-4">
              <span className="text-xs text-gray-500">电影</span>
              <span className="text-xs text-gray-500">电视剧</span>
              <span className="text-xs text-gray-500">综艺</span>
              <span className="text-xs text-gray-500">动漫</span>
              <span className="text-xs text-gray-500">高清</span>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}